import {Fragment, ReactElement} from "react";
import {useTranslation} from "next-i18next";

interface SidebarPropsInterface {
	children: ReactElement[];
	defaultSearchValue?: string;
	onSearchChange: (searchTerm: string) => void;
	resetFilters: () => void;
}

export default function Sidebar(props: SidebarPropsInterface) {
	const {t} = useTranslation();
	return (
		<div className="min-w-[390px] hidden xl:block">
			<div className="flex flex-col gap-10 shadow-md p-6">
				<div className="flex justify-between">
					<h4>{t("components.sidebar.filter")}</h4>{" "}
					<button className="text-leo-orange" onClick={props.resetFilters}>
						{t("components.sidebar.reset")}
					</button>
				</div>
				{/* <SearchField
          title={t("common.searchableFields")}
          onChange={props.onSearchChange}
        /> 
        <hr />*/}
				{props.children.map((c, idx) => (
					<Fragment key={idx}>
						{c}
						{idx < props.children.length - 1 && <hr/>}
					</Fragment>
				))}
			</div>
		</div>
	);
}
